// @flow
import * as React from 'react';
import { Item, Pagination } from './styles';
import { range } from 'lodash/fp';

type Props = {
    activePage: number,
    pages: number
};

export default ({ activePage, pages }: Props) => (
    <Pagination>
        {range(0, pages).map(index => <Item active={activePage === index} key={`item-${index}`} />)}
    </Pagination>
);



// WEBPACK FOOTER //
// ./src/components/widgets/mode-selector-slide/pagination/index.js